export default "__VITE_ASSET__1d95baf5__"